import {UpmEntityType} from '@hconnect/common/types'

import {useSettingsQuery} from '../../../common/providers/ApiInterface'

export const useEntityConfig = (upmPlantId: string, entityId?: string, type?: UpmEntityType) => {
  return useSettingsQuery('upmEntityConfig', [upmPlantId, entityId, type], {
    enabled: !!entityId,
    gcTime: 0,
    retry: false,
    staleTime: 0
  })
}

export const QueryKey = 'upmEntityConfig'
